import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { CartaServices } from '../../services';
import { Uploads } from '../../../services/uploads';
import { ConfigurationImagesPage } from '../../../configuration/configuration-images/configuration-images';

/**
 * Generated class for the MenuPartialCustomizeViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-carta-partial-customize-view',
    templateUrl: 'carta-partial-customize-view.html',
})
export class CartaPartialCustomizeViewPage {
    @Input() carta_uid: any;



    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public cartaServices: CartaServices,
        public uploadServices: Uploads) {
    }




    activePage(number) {
        this.cartaServices.page_active = number;
        this.cartaServices.getIndexOfPage();
        this.cartaServices.cleanEdit();
    }

    previusPage() {
        if (this.cartaServices.page_active > 1) {
            this.cartaServices.page_active -= 1;
        }
        this.cartaServices.getIndexOfPage();
        this.cartaServices.cleanEdit();
    }
    nextPage(number) {
        if (this.cartaServices.page_active < number) {
            this.cartaServices.page_active += 1
        }
        this.cartaServices.getIndexOfPage();
        this.cartaServices.cleanEdit();
    }

    getImageUrl($img_url) {
        if ($img_url != '') {
            $img_url = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/' + encodeURIComponent($img_url) + '?alt=media';
            return $img_url;
        } else {
            return '';
        }

    }

    _height_div;any
    styleA4(carta) {
        //Simulacion de la hoja de papel A4. Propocionalmente le ponemos la medida
        var width_div = document.getElementById('paper_sheet').offsetWidth;
        //Regla de 3 para encontrar la parte propocional para tener un A4 en pantalla.
        var base_width = 595.276; //A4
        var base_height = 841.89; //A4
        var percent = width_div * 100 / base_width;
        this.cartaServices.percent = percent;
        var height_div = base_height * percent / 100;
        this._height_div = height_div;
        let styles = {
            'height': height_div + 'px',
            'background-position': 'center',
            'background-repeat': 'no-repeat',
            '-webkit-background-size': 'cover',
            '-moz-background-size': 'cover',
            '-o-background-size': 'cover',
            'background-size': 'cover',
        };

        return styles;

    }

    styledivA4(page) {
/*
        var value = this._height_div / this.globals.objectToArray(page.sections).length;

        let styles = {
            'max-height': value +'px',
            'height': 160 * this.cartaServices.percent / 100 + 'px',
        };

        return styles;*/
    }

    setStylesNameSection(section) {
        let styles = {
            'text-align': section.text_align_sname,
            'font-family': section.font_family_sname,
            'color': section.font_color_sname,

        };
        return styles;
    }

    setStylesNameSectionDiv(section) {
        var fs = section.font_size_sname * this.cartaServices.percent / 100;
        let styles = {
            'font-size': fs + 'px ',
            'line-height': fs + 'px ',
        };
        return styles;
    }

    setStylesNameElement(section) {
        var fs = section.font_size_ename * this.cartaServices.percent / 100;

        let styles = {
            'font-family': section.font_family_ename,
            'color': section.font_color_ename,
            'font-size': fs + 'px',
            'line-height': fs + 'px ',
        };
        return styles;
    }

    setStylesDescriptionElement(section) {
        var fs = section.font_size_edescription * this.cartaServices.percent / 100;

        let styles = {
            'font-family': section.font_family_edescription,
            'color': section.font_color_edescription,
            'font-size': fs + 'px',
            'line-height': fs + 'px ',
        };
        return styles;
    }

    uploadImage() {
        this.globals.side_menu_config_active = 'images';
        this.navCtrl.push(ConfigurationImagesPage);
    }

    edit(value, index) {
        this.cartaServices.edit = true;
        this.cartaServices.edit_section = value;
        this.cartaServices.edit_index = index;
        this.cartaServices.edit_elements_array = this.globals.objectToArray(this.cartaServices.edit_section.elements);
        this.cartaServices.edit_type = 'element';
    }



}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-view/carta-partial-customize-view/carta-partial-customize-view.ts